import React from 'react'

import { useTranslation } from '@mc/i18n'
import { IconCloseDefault, IconSearchDefault, Input } from '@mc/design-system'

import { trackSearchStart } from '../../events'
import { useSearchContext } from './useSearchContext'
import { GreaterThanOrEqual, LessThan } from '../Media'
import classes from './Search.module.scss'

type InputProps = {
  setShow(show: boolean): void
  fullWidth?: boolean
}

export const SearchInput = React.forwardRef<HTMLDivElement, InputProps>(
  ({ setShow, fullWidth }, ref) => {
    const { t } = useTranslation('@mc/next')
    const { query, setQuery } = useSearchContext()

    const id = 'searchInput'

    const CancelSearch = () =>
      query.length ? (
        <button className='mc-clickable' onClick={() => setQuery('')}>
          <IconCloseDefault size='sm' className='mc-text-color--light' />
        </button>
      ) : null

    const inputProps = {
      id,
      onFocusCapture: () => {
        if (!query) trackSearchStart()
        setShow(true)
      },
      value: query,
      onChange: (e: React.ChangeEvent<HTMLInputElement>) => {
        setShow(true)
        setQuery(e.target?.value)
      },
      prepend: (
        <IconSearchDefault className='mc-ml-4 mc-mr-2 mc-my-2 mc-text-color--light' />
      ),
      append: <CancelSearch />,
    }

    const shortPlaceholder = t('nav.searchPlaceholder.short')

    const longPlaceholder = t('nav.searchPlaceholder.long')

    return (
      <div
        ref={ref}
        className={[
          'mc-search-input',
          classes.searchInput,
          fullWidth ? classes.fullWidth : '',
          classes.hasBrowseBtn,
        ].join(' ')}
      >
        <LessThan bp='xl'>
          <label htmlFor={id} className='mc-sr-only'>
            {shortPlaceholder}
          </label>
          <Input placeholder={shortPlaceholder} {...inputProps} />
        </LessThan>
        <GreaterThanOrEqual bp='xl'>
          <label htmlFor={id} className='mc-sr-only'>
            {longPlaceholder}
          </label>
          <Input placeholder={longPlaceholder} {...inputProps} />
        </GreaterThanOrEqual>
      </div>
    )
  },
)

SearchInput.displayName = 'SearchInput'

export const blurSearchInput = () => {
  document.querySelector<HTMLInputElement>('.mc-search-input input')?.blur()
}
